import { Link } from 'react-router'

import { BrandArcs, Logo } from '@/shared/components/brand'
import { Button } from '@/shared/components/ui/button'

import { ROUTES } from '../router/routes'

/** Página para cualquier URL que no exista. */
export function NotFoundPage() {
  return (
    <div className="bg-background relative flex min-h-screen flex-col items-center justify-center gap-5 overflow-hidden p-6 text-center">
      <BrandArcs
        corner="bottom-right"
        className="text-brand-gold/15 absolute -right-24 -bottom-24 size-[480px]"
      />

      <Logo variant="isotype" size={44} />

      <p className="font-serif text-7xl font-semibold tracking-tight">404</p>
      <div className="space-y-1">
        <h1 className="font-serif text-xl font-semibold">Página no encontrada</h1>
        <p className="text-muted-foreground text-sm">
          La dirección que buscas no existe o fue movida.
        </p>
      </div>
      <Button asChild>
        <Link to={ROUTES.ROOT}>Volver al inicio</Link>
      </Button>
    </div>
  )
}
